var React = require('react');

function Info (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15 14H17V22H15zM15 10H17V12H15z","key":0}),React.createElement("path",{"fill":"none","stroke":"#C3C3C3","strokeMiterlimit":"10","strokeWidth":"2","d":"M16 4A12 12 0 1 0 16 28A12 12 0 1 0 16 4Z","key":1})]);
}

Info.defaultProps = {"fill":"#C3C3C3","viewBox":"0 0 32 32","width":"32px","height":"32px"};

module.exports = Info;

Info.default = Info;
